/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { Component, OnInit } from '@angular/core';
import { AnalyticsService } from './@core/utils/analytics.service';
import { TranslateService } from '@ngx-translate/core';
import { LocalStorageService } from './@core/data/localstorage.service';
import { Title } from '@angular/platform-browser';
import * as moment from 'moment';
import { NbIconLibraries } from '@nebular/theme';

@Component({
  selector: 'ngx-app',
  template: '<router-outlet></router-outlet>',
})
export class AppComponent implements OnInit {

  private lang: string = 'zh-TW';

  constructor(
    private readonly analytics: AnalyticsService,
    public translate: TranslateService,
    private readonly localstorageservice: LocalStorageService,
    private titleService: Title,
    private iconLibraries: NbIconLibraries,
  ) {
    this.lang = (this.localstorageservice.getPreUseData().lang.match(/^en$|^zh-TW$/) ? localstorageservice.getPreUseData().lang : '');
    if (this.lang === '') {
      const browserLang = translate.getBrowserCultureLang();
      translate.setDefaultLang(browserLang.match(/^en$|^zh-TW$/) ? browserLang : 'en');
      translate.use(browserLang.match(/^en$|^zh-TW$/) ? browserLang : 'en');
    } else {
      translate.addLangs(['en', 'zh-TW']);
      translate.setDefaultLang(this.lang);
      translate.use(this.lang);
    }
    moment.locale(translate.currentLang);
    // 註冊Icon
    this.iconLibraries.registerFontPack('font-awesome', { packClass: 'fal', iconClassPrefix: 'fa' });
  }

  ngOnInit(): void {
    this.analytics.trackPageViews();
    this.translate.onLangChange.subscribe(() => {
      this.titleService.setTitle(this.translate.instant('AppTitle'));
      moment.locale(this.translate.currentLang);
    });
  }

}
